import React, { useState } from 'react';
import { HiOutlinePlus, HiOutlineTrash } from 'react-icons/hi2';

const WorkPermitStep3Hazards = ({ formData, handleArrayChange }) => {
  const hazards = JSON.parse(formData.hazardsJson || '[]');
  const [newHazard, setNewHazard] = useState({ hazardType: '', hazardDescription: '', riskLevel: 'Medium', controlMeasures: '' });

  const addHazard = () => {
    if (!newHazard.hazardType && !newHazard.hazardDescription) return;
    handleArrayChange('hazardsJson', [...hazards, { ...newHazard }]);
    setNewHazard({ hazardType: '', hazardDescription: '', riskLevel: 'Medium', controlMeasures: '' });
  };

  const removeHazard = (index) => {
    const copy = [...hazards];
    copy.splice(index, 1);
    handleArrayChange('hazardsJson', copy);
  };

  return (
    <div className="work-permit-step">
      <h3 className="form-section-title">3. Hazards & Controls</h3>
      <div className="array-field-container">
        {hazards.length === 0 && <p>No hazards added yet.</p>}
       
        {hazards.map((h, idx) => (
          <div key={idx} className='form-row'>
            <div className="form-group ">
            <input
              type="text"
              value={h.hazardType}
              onChange={(e) => {
                const copy = [...hazards];
                copy[idx].hazardType = e.target.value;
                handleArrayChange('hazardsJson', copy);
              }}
              className='form-'
              placeholder="Hazard type"
            />
            </div>
            <div className="form-group ">
            <input
              type="text"
              value={h.hazardDescription}
              onChange={(e) => {
                const copy = [...hazards];
                copy[idx].hazardDescription = e.target.value;
                handleArrayChange('hazardsJson', copy);
              }}
              placeholder="Description"
            />
            </div>
            <div className="form-group ">
            <select
              value={h.riskLevel}
              onChange={(e) => {
                const copy = [...hazards];
                copy[idx].riskLevel = e.target.value;
                handleArrayChange('hazardsJson', copy);
              }}
            >
              <option value="Low">Low</option>
              <option value="Medium">Medium</option>
              <option value="High">High</option>
              <option value="Critical">Critical</option>
            </select>
            </div>
            <div className="form-group ">
            <input
              type="text"
              value={h.controlMeasures}
              onChange={(e) => {
                const copy = [...hazards];
                copy[idx].controlMeasures = e.target.value;
                handleArrayChange('hazardsJson', copy);
              }}
              placeholder="Controls / mitigations"
            />
            </div>
            <button type="button" className="btn-icon-delete" onClick={() => removeHazard(idx)}>
              <HiOutlineTrash />
            </button>
          </div>
        ))} 
         <div className="form-row">
        <div className="form-group ">
          <input
            type="text"
            value={newHazard.hazardType}
            onChange={(e) => setNewHazard((prev) => ({ ...prev, hazardType: e.target.value }))}
            placeholder="Hazard type"
          />
          </div>
          <div className="form-group "> 
          <input
            type="text"
            value={newHazard.hazardDescription}
            onChange={(e) => setNewHazard((prev) => ({ ...prev, hazardDescription: e.target.value }))}
            placeholder="Description"
          />
          </div>
          <div className="form-group "> 
          <select
            value={newHazard.riskLevel}
            onChange={(e) => setNewHazard((prev) => ({ ...prev, riskLevel: e.target.value }))}
          >
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
            <option value="Critical">Critical</option>
          </select>
          </div>
          <div className="form-group "> 
          <input
            type="text"
            value={newHazard.controlMeasures}
            onChange={(e) => setNewHazard((prev) => ({ ...prev, controlMeasures: e.target.value }))}
            placeholder="Controls / mitigations"
          />
          </div>
          <button type="button" className="btn-primary wd50size" onClick={addHazard}>
            <HiOutlinePlus />
          </button>
          
        </div>
      </div>
    </div>
  );
};

export default WorkPermitStep3Hazards;

